// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Caudex:ital,wght@0,400;0,700;1,400;1,700&family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #675954;
}

body {
  font-family: "Cormorant Garamond", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

button {
  cursor: pointer;
}
header {
  background: var(--primary);
}
nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  padding: 1rem 3rem;
  font-weight: 600;
  font-size: 2rem;

  button {
    color: #fff;
    background: transparent;
    border: none;
  }

  .right {
    display: flex;
    gap: 2rem;

    & button {
      padding-inline: 0.5rem;
      border: solid 2px transparent;

      &.active {
        border-color: #fffc;
      }
    }
  }
}

#home {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-family: "Caudex", serif;
  font-size: 3rem;
}

#content {
  padding: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf;IACE,WAAW;IACX,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;;IAET;MACE,sBAAsB;MACtB,6BAA6B;;MAE7B;QACE,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Caudex:ital,wght@0,400;0,700;1,400;1,700&family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&display=swap\");\n\n:root {\n  --primary: #675954;\n}\n\nbody {\n  font-family: \"Cormorant Garamond\", serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n}\n\nbutton {\n  cursor: pointer;\n}\nheader {\n  background: var(--primary);\n}\nnav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n  padding: 1rem 3rem;\n  font-weight: 600;\n  font-size: 2rem;\n\n  button {\n    color: #fff;\n    background: transparent;\n    border: none;\n  }\n\n  .right {\n    display: flex;\n    gap: 2rem;\n\n    & button {\n      padding-inline: 0.5rem;\n      border: solid 2px transparent;\n\n      &.active {\n        border-color: #fffc;\n      }\n    }\n  }\n}\n\n#home {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  font-family: \"Caudex\", serif;\n  font-size: 3rem;\n}\n\n#content {\n  padding: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
